<template>
    <div>

        <!-- DIALOGO DE CONFIRMACION -->
        <q-dialog v-model="dialogConfirm" persistent>
            <q-card>
                <q-card-section class="row items-center">
                    <div class="row no-wrap q-pa-md ">
                        <div class="column text-center">
                            <q-avatar size="80px" icon="mdi-delete-alert" color="warning" text-color="white" />
                        </div>
                        <q-separator vertical inset class="q-mx-lg" />
                        <div class="column text-center">
                            <span class="text-h5 q-ml-lg">¿Estas seguro de eliminar el Personal <strong>{{ item.nombre
                                    }}</strong> .?</span>
                        </div>
                    </div>
                </q-card-section>
                <q-card-actions align="right">
                    <q-btn label="CANCELAR" @click="cancelarDelete()" />
                    <q-btn label="Aceptar" color="primary" @click="DeleteItem()" />
                </q-card-actions>
            </q-card>
        </q-dialog>

        <q-card style="width: 700px; max-width: 80vw;background: #f8fcff">
            <q-bar class="bg-primary text-white">
                <q-icon name="mdi-bank" />
                <div>Personal</div>
                <q-space />
                <q-btn dense flat icon="close" v-close-popup>
                    <q-tooltip>Close</q-tooltip>
                </q-btn>
            </q-bar>
            <q-card-section>
                <q-form class="q-gutter-md">
                    <q-table :loading="loading" dense :data="dataList" :columns="columns">
                        <template v-slot:loading>
                            <q-inner-loading showing color="primary" />
                        </template>
                        <template v-slot:top>
                            <div class="row q-pb-sm full-width">
                                Datos del Personal
                                <q-space />
                                <q-btn v-if="template == false" push round icon="mdi-plus" @click="crearItem()" />
                                <q-btn v-if="template == true" push round icon="mdi-minus" class="q-mr-sm"
                                    @click="cancelar" />
                                <q-btn v-if="template == true && item._id == ''" color="primary" push round
                                    icon="mdi-content-save" @click="PostItem()" />
                                <q-btn v-if="template == true && item._id != ''" color="primary" push round
                                    icon="mdi-pencil" @click="PutItem()" />
                            </div>

                            <div class="row full-width" v-if="template == true">
                                <div class="col-12 q-mb-md">
                                    <q-input dense filled v-model="item.nombre" label="Nombre completo de la Persona" />
                                </div>
                                <div class="col-12 q-mb-md">
                                    <q-input dense filled v-model="item.correo" label="Correo" />
                                </div>
                                <div class="col-12 q-mb-md">
                                    <q-input dense filled v-model="item.password" label="Password" />
                                </div>
                            </div>
                        </template>
                        <template v-slot:body="props">
                            <q-tr :props="props">
                                <q-td auto-width key="acciones">
                                    <q-btn size="md" color="primary" rounded flat dense @click="editarItem(props.row)"
                                        icon="mdi-pencil">
                                        <q-tooltip transition-show="flip-right" transition-hide="flip-left"
                                            content-style="font-size: 14px">Editar</q-tooltip>
                                    </q-btn>
                                    <q-btn v-if="props.row.estatus == 'Vigente'" size="md" style="color:#CC003D" rounded
                                        flat dense @click="eliminarItem(props.row)" icon="mdi-delete">
                                        <q-tooltip transition-show="flip-right" transition-hide="flip-left"
                                            content-style="font-size: 14px">Eliminar</q-tooltip>
                                    </q-btn>
                                    <q-btn v-if="props.row.estatus == 'Asignado'" size="md" color="blue" rounded flat
                                        dense icon="mdi-eye" @click="GetBasesXPersonal(props.row)">
                                        <q-tooltip transition-show="flip-right" transition-hide="flip-left"
                                            content-style="font-size: 14px">Ver Datos</q-tooltip>
                                        <q-menu>
                                            <q-list>
                                                <q-separator />
                                                <q-item v-for="a in unidadesPorUsuario" :key="a._id">
                                                    <q-item-section avatar>
                                                        <q-icon name="mdi-hospital-building" />
                                                    </q-item-section>
                                                    <q-item-section>
                                                        <q-item-label v-html="a.nombre_unidad" />
                                                        <q-item-label caption>{{ a.nombre_sede + ', ' +
                                                            a.nombre_tipo_unidad
                                                        }}</q-item-label>
                                                    </q-item-section>
                                                </q-item>
                                            </q-list>
                                        </q-menu>
                                    </q-btn>
                                </q-td>
                                <q-td key="nombre" :props="props">{{ props.row.nombre }}</q-td>
                                <q-td key="correo" :props="props">{{ props.row.correo }}</q-td>
                                <!-- <q-td key="password" :props="props">{{ props.row.password }}</q-td> -->
                            </q-tr>
                        </template>
                    </q-table>
                </q-form>
            </q-card-section>
        </q-card>
    </div>
</template>
<script>
import { format } from 'date-fns';
import { QSpinnerFacebook } from 'quasar'
import moment from 'moment';
import axios from "axios";
export default {

    components: {
    },

    data() {
        return {
            template: false,
            columns: [
                { name: 'acciones', align: 'center', label: 'Acciones', field: 'acciones', classes: 'bg-grey-2 ellipsis text-center', headerClasses: 'bg-primary text-white text-center' },
                { name: 'nombre', align: 'center', label: 'Nombre', field: 'nombre', sortable: true, classes: 'bg-grey-2 ellipsis text-center', headerClasses: 'bg-primary text-white text-center' },
                { name: 'correo', align: 'center', label: 'Correo', field: 'correo', sortable: true, classes: 'bg-grey-2 ellipsis text-center', headerClasses: 'bg-primary text-white text-center' },
                // { name: 'password', align: 'center', label: 'Password', field: 'password', sortable: true, classes: 'bg-grey-2 ellipsis text-center', headerClasses: 'bg-primary text-white text-center' },
            ],
            loading: false,
            dialogConfirm: false,
            unidadesPorUsuario: []
        }
    },
    computed: {
        usuarioStore() {
            return this.$store.state.usuario
        },
        item() {
            return this.$store.state.personalStore
        },
        dataList() {
            return this.$store.state.dataPersonalStore
        }
    },
    created() {
        this.GetPersonal()
    },
    methods: {
        crearItem() {
            this.template = true
        },
        eliminarItem(item) {
            this.$store.state.personalStore = { ...item }
            this.dialogConfirm = true
        },
        cancelar() {
            this.template = false
            this.$store.state.personalStore = {
                _id: '',
                nombre: '',
                correo: '',
                password: '',
                usuario_creador: this.usuarioStore.email,
                fecha_creacion: '',
                estatus: 'Vigente'
            }
        },
        cancelarDelete() {
            this.$store.state.personalStore = {
                _id: '',
                nombre: '',
                correo: '',
                password: '',
                usuario_creador: this.usuarioStore.email,
                fecha_creacion: '',
                estatus: 'Vigente'
            }
            this.dialogConfirm = false
        },
        async PostItem() {
            if (this.$store.state.usuario.rol != 'Administrador') {
                this.$q.notify({
                    position: 'top-right',
                    message: 'El usuario no cuenta con los permisos necesarios para realizar esta acción.',
                    color: 'info',
                    icon: 'warning'
                })
                return
            }

            if (this.item.nombre == '') {
                this.$q.notify({ type: 'warning', position: 'top-right', message: 'Indique el nombre de la Persona.' })
                return;
            }
            if (this.item.correo == '') {
                this.$q.notify({ type: 'warning', position: 'top-right', message: 'Indique el nombre de la Persona.' })
                return;
            }
            if (this.item.password == '') {
                this.$q.notify({ type: 'warning', position: 'top-right', message: 'Indique una contraseña.' })
                return;
            }

            let fecha = new Date()
            let fechaC = format(fecha, "yyyy-MM-dd HH:mm:ss");
            this.item.fecha_creacion = fechaC
            this.$q.loading.show({ spinner: QSpinnerFacebook, spinnerColor: 'white', spinnerSize: 140, message: 'Guardando Personal. Espere...', messageColor: 'white' })
            try {
                let respuesa = await axios.post('Configuracion/PostPersonal/config_inventarios', this.item)
                this.$q.notify({ position: 'top-right', type: 'positive', message: `Información guardada exitosamente.` })
                console.log(respuesa)
                this.$q.loading.hide()

                this.cancelar();
                await this.GetPersonal();
            } catch (error) {
                this.$q.loading.hide()
                console.log(error)
            }
        },
        editarItem(item) {
            if (this.$store.state.usuario.rol != 'Administrador') {
                this.$q.notify({
                    position: 'top-right',
                    message: 'El usuario no cuenta con los permisos necesarios para realizar esta acción.',
                    color: 'info',
                    icon: 'warning'
                })
                return
            }
            this.$store.state.personalStore = { ...item }
            this.template = true
        },
        async PutItem() {
            if (this.$store.state.usuario.rol != 'Administrador') {
                this.$q.notify({
                    position: 'top-right',
                    message: 'El usuario no cuenta con los permisos necesarios para realizar esta acción.',
                    color: 'info',
                    icon: 'warning'
                })
                return
            }
            if (this.item.nombre == '') {
                this.$q.notify({ type: 'warning', position: 'top-right', message: 'Indique el nombre de la Persona.' })
                return;
            }
            if (this.item.correo == '') {
                this.$q.notify({ type: 'warning', position: 'top-right', message: 'Indique el nombre de la Persona.' })
                return;
            }
            if (this.item.password == '') {
                this.$q.notify({ type: 'warning', position: 'top-right', message: 'Indique una contraseña.' })
                return;
            }

            let fecha = new Date()
            let fechaC = format(fecha, "yyyy-MM-dd HH:mm:ss");
            this.item.fecha_creacion = fechaC
            this.$q.loading.show({ spinner: QSpinnerFacebook, spinnerColor: 'white', spinnerSize: 140, message: 'Actualizando Personal. Espere...', messageColor: 'white' })
            try {
                let respuesa = await axios.put('Configuracion/PutPersonal/config_inventarios', this.item)
                this.$q.notify({ position: 'top-right', type: 'positive', message: `Información actualizasa exitosamente.` })
                console.log(respuesa)
                this.$q.loading.hide()

                this.cancelar();
                await this.GetPersonal();
            } catch (error) {
                this.$q.loading.hide()
                console.log(error)
            }
        },
        async DeleteItem() {
            if (this.$store.state.usuario.rol != 'Administrador') {
                this.$q.notify({
                    position: 'top-right',
                    message: 'El usuario no cuenta con los permisos necesarios para realizar esta acción.',
                    color: 'info',
                    icon: 'warning'
                })
                return
            }

            this.$q.loading.show({ spinner: QSpinnerFacebook, spinnerColor: 'white', spinnerSize: 140, message: 'Eliminando Personal. Espere...', messageColor: 'white' })
            try {
                let respuesa = await axios.post('Configuracion/DeletePersonal/config_inventarios/' + this.item._id,)
                this.$q.notify({ position: 'top-right', type: 'positive', message: `El personal se ha eliminado correctamente.` })
                console.log(respuesa)
                this.$q.loading.hide()
                this.cancelarDelete();
                await this.GetPersonal();

            } catch (error) {
                this.$q.loading.hide()
                console.log(error)
            }
        },
        async GetPersonal() {
            this.loading = true
            try {
                let respuesa = await axios.get('Configuracion/GetPersonalTodos/config_inventarios')
                console.log(respuesa)
                this.loading = false
                this.$store.state.dataPersonalStore = respuesa.data
            } catch (error) {
                this.loading = false
                console.log(error)
            }
        },

        async GetBasesXPersonal(item) {
            if (this.$store.state.usuario.rol != 'Administrador') {
                this.$q.notify({
                    position: 'top-right',
                    message: 'El usuario no cuenta con los permisos necesarios para realizar esta acción.',
                    color: 'info',
                    icon: 'warning'
                })
                return
            }
            console.log(item)
            try {
                let respuesa = await axios.get('Configuracion/GetBaseDatosMovil/' + item._id)
                console.log(respuesa)
                this.unidadesPorUsuario = respuesa.data.lista
            } catch (error) {
                console.log(error)
            }
        },
    }
}
</script>